import { render, staticRenderFns } from "./InvoiceAreaSidebar.vue?vue&type=template&id=544e3d33&"
import script from "./InvoiceAreaSidebar.vue?vue&type=script&lang=js&"
export * from "./InvoiceAreaSidebar.vue?vue&type=script&lang=js&"
import style0 from "./InvoiceAreaSidebar.vue?vue&type=style&index=0&module=true&lang=css&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports